import { faChartNetwork } from '@fortawesome/pro-regular-svg-icons/faChartNetwork';
import { faCoins } from '@fortawesome/pro-regular-svg-icons/faCoins';
import { faMousePointer } from '@fortawesome/pro-regular-svg-icons/faMousePointer';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import { subDays, subMonths } from 'date-fns';
import colors from 'tailwindcss/colors';

import { conversionFuncs } from '@hooks/useFilters';

// Виды сортировок по умолчанию
const ORDER_BY_DAY = {
    order: 'day',
    orderDirection: 'desc',
};

const ORDER_BY_MONTH = {
    order: 'month',
    orderDirection: 'desc',
};

const ORDER_BY_REVENUE_HOLD = {
    order: 'revenueHold',
    orderDirection: 'desc',
};

// Направления сортировки по умолчанию для всех типов
export const DEFAULT_ORDERS = {
    day: ORDER_BY_DAY,
    hour: ORDER_BY_DAY,
    month: ORDER_BY_MONTH,
    offer: ORDER_BY_REVENUE_HOLD,
    creative: ORDER_BY_REVENUE_HOLD,
    sub: ORDER_BY_REVENUE_HOLD,
    sub2: ORDER_BY_REVENUE_HOLD,
    sub3: ORDER_BY_REVENUE_HOLD,
    sub4: ORDER_BY_REVENUE_HOLD,
    sub5: ORDER_BY_REVENUE_HOLD,
    country: ORDER_BY_REVENUE_HOLD,
    os: ORDER_BY_REVENUE_HOLD,
    material: ORDER_BY_REVENUE_HOLD,
    placement: ORDER_BY_REVENUE_HOLD,
};

export const DEFAULT_FILTERS = {
    offerIds: 0,
    creativeIds: null,
    placement: null,
    placementIds: null,
    currency: 'USD',
    dateFrom: subDays(new Date(), 6),
    dateTo: new Date(),
    type: 'day',
    sub: null,
    sub2: null,
    sub3: null,
    sub4: null,
    sub5: null,
};

export const filtersConversionFuncs = {
    offerIds: conversionFuncs.number,
    creativeIds: conversionFuncs.string,
    placement: conversionFuncs.string,
    placementIds: conversionFuncs.string,
    currency: conversionFuncs.string,
    dateFrom: conversionFuncs.date,
    dateTo: conversionFuncs.date,
    type: conversionFuncs.string,
    sub: conversionFuncs.string,
    sub2: conversionFuncs.string,
    sub3: conversionFuncs.string,
    sub4: conversionFuncs.string,
    sub5: conversionFuncs.string,
};

// Виды графиков для различных вкладок
export const CHART_OPTIONS_BY_TYPE = {
    day: {
        type: 'line',
    },
    hour: {
        type: 'line',
    },
    month: {
        type: 'line',
    },
    offer: {
        type: 'bar',
    },
    creative: {
        type: 'bar',
    },
    sub: {
        type: 'bar',
    },
    sub2: {
        type: 'bar',
    },
    sub3: {
        type: 'bar',
    },
    sub4: {
        type: 'bar',
    },
    sub5: {
        type: 'bar',
    },
    country: {
        type: 'bar',
    },
    os: {
        type: 'bar',
    },
    material: {
        type: 'bar',
    },
    placement: {
        type: 'bar',
    },
};

export const datePeriods = {
    today: {
        dateFrom: new Date(),
        dateTo: new Date(),
    },
    yesterday: {
        dateFrom: subDays(new Date(), 1),
        dateTo: new Date(),
    },
    week: {
        dateFrom: subDays(new Date(), 6),
        dateTo: new Date(),
    },
    month: {
        dateFrom: subMonths(new Date(), 1),
        dateTo: new Date(),
    },
    halfYear: {
        dateFrom: subMonths(new Date(), 6),
        dateTo: new Date(),
    },
};

export const LIMIT = 30;

export const subsList = ['sub', 'sub2', 'sub3', 'sub4', 'sub5'];

export const ALL_CURRENCIES = [
    {
        label: 'USD',
        value: 'USD',
    },
    {
        label: 'RUB',
        value: 'RUB',
    },
    {
        label: 'EUR',
        value: 'EUR',
    },
    {
        label: 'GBP',
        value: 'GBP',
    },
];

export const ALL_CURRENCIES_WITH_TON = [
    ...ALL_CURRENCIES,
    {
        label: 'TON',
        value: 'TON',
    },
];

export const dateRanges = [
    {
        key: 'Today',
        value: 'today',
        id: 'today',
    },
    {
        key: 'Yesterday',
        value: 'yesterday',
        id: 'yesterday',
    },
    {
        key: 'Week',
        value: 'week',
        id: 'week',
    },
    {
        key: 'Month',
        value: 'month',
        id: 'month',
    },
    {
        key: 'Half-year',
        value: 'halfYear',
        id: 'halfYear',
    },
];

export const typeFilterOptions = [
    {
        key: 'Days',
        value: 'day',
    },
    {
        key: 'Hours',
        value: 'hour',
    },
    // {
    //     key: 'Months',
    //     value: 'month',
    // },
    {
        key: 'Offers',
        value: 'offer',
    },
    {
        key: 'Creatives',
        value: 'creative',
    },
    {
        key: 'SUB',
        options: [
            {
                key: 'SUB',
                value: 'sub',
            },
            {
                key: 'SUB 2',
                value: 'sub2',
            },
            {
                key: 'SUB 3',
                value: 'sub3',
            },
            {
                key: 'SUB 4',
                value: 'sub4',
            },
            {
                key: 'SUB 5',
                value: 'sub5',
            },
        ],
    },
    {
        key: 'Countries',
        value: 'country',
    },
    {
        key: 'Os',
        value: 'os',
    },
    {
        key: 'Materials',
        value: 'material',
    },
    {
        key: 'Placements',
        value: 'placement',
    },
];

export const columnByType = {
    day: 'date',
    hour: 'date',
    month: 'date',
    offer: 'offerId',
    creative: 'creativeId',
    sub: 'sub',
    sub2: 'sub2',
    sub3: 'sub3',
    sub4: 'sub4',
    sub5: 'sub5',
    country: 'countryCode',
    os: 'os',
    material: 'material',
    placement: 'placementId',
};

export const commonChartLineOptions = {
    pointHoverBorderColor: colors.white,
    // ширина точки
    pointRadius: 5,
    // ширина точки при наведении
    pointHoverRadius: 6,
    // ширина бордера при наведении
    pointHoverBorderWidth: 4,
    // плавность линии
    lineTension: 0,
};

export const chartLineOptions = {
    revenueHold: {
        label: 'Revenue hold',
        data: [],
        // barThickness: 5,
        yAxisID: 'revenue',
        backgroundColor: colors.violet[500],
        borderColor: colors.violet[500],
        type: 'bar',
    },
    revenue: {
        label: 'Revenue',
        data: [],
        // barThickness: 5,
        yAxisID: 'revenue',
        backgroundColor: colors.violet[800],
        borderColor: colors.violet[800],
        type: 'bar',
    },
    clicks: {
        label: 'Clicks',
        data: [],
        backgroundColor: colors.emerald[300],
        borderColor: colors.emerald[300],
        id: 'clicks',
    },
    hosts: {
        label: 'Hosts',
        data: [],
        backgroundColor: colors.red[400],
        borderColor: colors.red[400],
    },
    leadsHold: {
        label: 'Leads hold',
        data: [],
        backgroundColor: colors.sky[500],
        borderColor: colors.sky[500],
    },
    leads: {
        label: 'Leads',
        data: [],
        backgroundColor: colors.blue[500],
        borderColor: colors.blue[500],
    },
    impressions: {
        label: 'Impressions',
        data: [],
        backgroundColor: colors.green[500],
        borderColor: colors.green[500],
    },
    turnover: {
        label: 'Turnover',
        data: [],
        backgroundColor: colors.amber[400],
        borderColor: colors.amber[400],
    },
};

export const LABELS_INFO_BY_TYPE = {
    day: {
        propertyName: 'date',
        isDate: true,
        formatString: 'dd.MM.yyyy',
    },
    hour: {
        propertyName: 'date',
        isDate: true,
        formatString: 'dd.MM.yyyy HH:mm',
    },
    month: {
        propertyName: 'date',
        isDate: true,
        formatString: 'LLLL yyyy',
    },
    offer: {
        propertyName: 'offerId',
        isNeedMapping: true,
    },
    creative: {
        propertyName: 'creativeName',
        propertyName2: 'creativeId',
        // isNeedMapping: true,
    },
    sub: {
        propertyName: 'sub',
    },
    sub2: {
        propertyName: 'sub',
    },
    sub3: {
        propertyName: 'sub',
    },
    sub4: {
        propertyName: 'sub',
    },
    sub5: {
        propertyName: 'sub',
    },
    country: {
        propertyName: 'countryCode',
    },
    os: {
        propertyName: 'os',
    },
    material: {
        propertyName: 'material',
    },
    placement: {
        propertyName: 'placement',
    },
};

export const tableColumnsInfo = [
    {
        key: 'Clicks',
        order: 'clicks',
    },
    {
        key: 'Hosts',
        order: 'hosts',
    },
    {
        key: 'Cr',
    },
    {
        key: 'Epc',
    },
    {
        key: 'Turnover',
        order: 'turnover',
    },
    {
        key: 'Leads',
        circleColor: colors.blueGray[300],
        order: 'leadsHold',
    },
    {
        key: 'Leads',
        circleColor: colors.green[500],
        order: 'leads',
    },
    {
        key: 'Revenue',
        circleColor: colors.blueGray[300],
        order: 'revenueHold',
    },
    {
        key: 'Revenue',
        circleColor: colors.green[500],
        order: 'revenue',
    },
];

/**
 * Используется для REF офферов
 */
export const tableColumnsWithSignups = [
    {
        key: 'Clicks',
        order: 'clicks',
    },
    {
        key: 'Hosts',
        order: 'hosts',
    },
    {
        key: 'Signups',
        order: false,
    },
    {
        key: 'Cr',
    },
    {
        key: 'Epc',
    },
    {
        key: 'Turnover',
        order: 'turnover',
    },
    {
        key: 'Leads',
        circleColor: colors.blueGray[300],
        order: 'leadsHold',
    },
    {
        key: 'Leads',
        circleColor: colors.green[500],
        order: 'leads',
    },
    {
        key: 'Revenue',
        circleColor: colors.blueGray[300],
        order: 'revenueHold',
    },
    {
        key: 'Revenue',
        circleColor: colors.green[500],
        order: 'revenue',
    },
];

export const firstColumnsInfo = {
    day: {
        key: 'Date',
        order: 'day',
    },
    hour: {
        key: 'Date',
        order: 'day',
    },
    month: {
        key: 'Date',
        order: 'month',
    },
    offer: {
        key: 'Offer',
        order: 'offer',
    },
    creative: {
        key: 'Creative',
        order: 'creative',
    },
    sub: {
        key: 'SUB',
        order: 'sub',
    },
    sub2: {
        key: 'SUB 2',
        order: 'sub2',
    },
    sub3: {
        key: 'SUB 3',
        order: 'sub3',
    },
    sub4: {
        key: 'SUB 4',
        order: 'sub4',
    },
    sub5: {
        key: 'SUB 5',
        order: 'sub5',
    },
    country: {
        key: 'Country',
        order: 'country',
    },
    os: {
        key: 'Os',
        order: 'os',
    },
    material: {
        key: 'Material',
        order: 'material',
    },
    placement: {
        key: 'Placement',
        order: 'placement',
    },
};

export const dayStatConfig = [
    {
        field: 'leadsHold',
        icon: faUsers,
        label: 'Leads',
        iconColor: 'blue',
    },
    {
        field: 'revenueHold',
        icon: faCoins,
        isCurrency: true,
        label: 'Revenue',
        iconColor: 'violet',
    },
    {
        field: 'clicks',
        icon: faMousePointer,
        label: 'Clicks',
        iconColor: 'green',
    },
    {
        field: 'hosts',
        icon: faChartNetwork,
        label: 'Hosts',
        iconColor: 'red',
    },
];

export const HINTS = {
    DEFAULT: {
        day: null,
        clicks: null,
        hosts: 'Unique users within a day',
        cr: 'Conversion Rate = (Leads on Hold + Leads) / Hosts * 100% - conversion rate',
        epc: 'Earn Per Click = (Revenue on Hold + Revenue) / Clicks - revenue from one click',
        turnover: null,
        leadsHold: 'Leads on hold',
        leads: 'Confirmed leads',
        revenueHold: 'Revenue on hold',
        revenue: 'Confirmed revenue',
    },
    REF: {
        day: null,
        clicks: null,
        hosts: 'Unique users within a day',
        cr: 'Conversion rate. Conversion rate equals to registrations / hosts * 100%',
        epc:
            'Revenue from one click. ePC is calculated by the following formula: ePC = (Revenue on hold + Revenue) / Clicks',
        turnover: 'General sum of purchases made by your referrals within the offer',
        leadsHold: 'The actions of your referrals on the side of the offer that are in process',
        leads: 'Confirmed actions of referrals on the side of the offer',
        revenueHold: 'Your revenue on hold from your referrals',
        revenue: 'Your confirmed revenue from your referrals',
    },
};

export const MONTH_DATE_REGEXP = /^(\d{2}) ([A-Z][a-z]{2}) (\d{4})$/;
export const MONTH_YEAR_REGEXP = /^([A-Z][a-z]{2}) (\d{4})$/;
